import styled from 'styled-components';

export const DateContainer = styled.div`
  width: 100%;
  .MuiTextField-root {
    width: 100%;
  }
  .MuiOutlinedInput-root {
    border-radius: 15px;
  }
  .MuiFormControl-root {
    margin: 0;
  }
`;
